<template>
    <div class="flex items-center url text-13 text-dark bitkub-url">
        <div class="bitkub-url _url leading-none transform ff-reg">
            https://app.bitkubnext.com
        </div>
    </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: 'BitkubNextUrl',
})
</script>

<style lang="scss" scoped>
@import "@/module/YesCoin/style/base.scss";

$dark: #313131;

.url {

    @extend %base-class;

    background-image: url("~@/module/YesCoin/assets/howto/yc-link-box.svg");
    background-repeat: no-repeat;
    background-size: 100%;
    height: 32px;
    width: 206px;

    ._url {
        margin-left: 32px;
    }
}

.text-dark {
    color: $dark;
}
</style>
